module.exports = __webpack_public_path__ + "img/tu1@2x.0c07e00f.png";